import * as React from 'react';

export function MicIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<path d='M12 19v3' />
			<path d='M19 10v2a7 7 0 0 1-14 0v-2' />
			<rect x='9' y='2' width='6' height='13' rx='3' />
		</svg>
	);
}
